import { useState } from 'react';
import { Form, Row, Col, Button, Toast } from 'react-bootstrap';
import { addExperience, removeExperience } from '../store/experienceSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { Education, Internship, Work } from '../interfaces/store';

const Experience = ({ type }: { type: 'work' | 'internship' | 'education' }) => {
  const dispatch = useDispatch();

  const experiencesData = useSelector((state: RootState) => state.experienceSlice);
  const work: Work[] = [];
  const internships = [];
  const educations = [];


  for (const experience of experiencesData) {
    switch (experience.type) {
      case 'work':
        let workExp: Work = {
          role: experience.role as string,
          city: experience.city,
          company: experience.company,
          description: experience.description,
          endDate: experience.endDate,
          startDate: experience.startDate,
          present: experience.present,
          id: experience.id
        }

        work.push(workExp)
        break;
      case 'internship':
        let intExp: Internship = {
          role: experience.role as string,
          description: experience.description,
          institution: experience.institution as string,
          endDate: experience.endDate as string,
          startDate: experience.startDate,
          present: experience.present,
          id: experience.id,
          city: experience.city,
          company: experience.company as string
        }
        internships.push(intExp)
        break;
      case 'education':
        let eduExp: Education = {
          education: experience.education as string,
          description: experience.description,
          institution: experience.institution as string,
          endDate: experience.endDate as string,
          startDate: experience.startDate,
          present: experience.present,
          id: experience.id,
          city: experience.city
        }
        educations.push(eduExp)
        break;
    }
  }
  const [role, setRole] = useState('');
  const [education, setEducation] = useState('');
  const [institution, setInstitution] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [present, setPresent] = useState(false);
  const [description, setDescription] = useState('');
  const [city, setCity] = useState('');
  const [company, setCompany] = useState('');
  
  // State for managing error message
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  // Handle form submission
  const handleDelete = () => {
    dispatch(removeExperience(type === 'work' || type === 'internship' ? role : education));
  };

  const handleAdd = () => {
    // Validate required fields
    if (!startDate || !city || !description || (type === 'education' && !education) || (type !== 'education' && !role)) {
      setErrorMessage('Please fill out all required fields.');
      return;
    }

    const payload: any = {
      type,
      startDate,
      endDate: present ? undefined : endDate,
      present,
      description,
      city,
    };

    if (type === 'work' || type === 'internship') {
      if (!company) {
        setErrorMessage('Please fill out the company field.');
        return;
      }
      payload.role = role;
      payload.id = role;
      payload.company = company;
    }

    if (type === 'education') {
      payload.id = education;
      payload.education = education;
      payload.institution = institution;
    }

    // Reset form
    setRole('');
    setInstitution('');
    setEndDate('');
    setStartDate('');
    setCity('');
    setEducation('');
    setPresent(false);
    setDescription('');
    setCompany('');
    setErrorMessage(null); // Clear any previous error message
    dispatch(addExperience(payload));
  };

  return (
    <div className="mb-4">
      {errorMessage && (
        <Toast
          onClose={() => setErrorMessage(null)}
          style={{
            position: 'fixed',
            bottom: '10px',
            right: '10px',
            zIndex: 1050,
            backgroundColor: 'rgb(59, 130, 246)', // Set background color
            color: 'white', // Set text color to white for contrast
          }}
        >
          <Toast.Header>{errorMessage}</Toast.Header>
        </Toast>
      )}

      {type === 'education' ? (
        <Row className="mb-2">
          <Col>
            <Form.Label>
              Education <span style={{ color: 'red' }}>*</span>
            </Form.Label>
            <Form.Control 
              onPaste={(e: any) => {
                e.preventDefault();
                alert('copy pasting is not allowed')
                return false;
              }}
              placeholder="Education" 
              value={education} 
              onChange={e => setEducation(e.target.value)} 
              required 
            />
          </Col>
          <Col>
            <Form.Label>
              Institution <span style={{ color: 'red' }}>*</span>
            </Form.Label>
            <Form.Control
              onPaste={(e: any) => {
                e.preventDefault();
                alert('copy pasting is not allowed')
                return false;
              }} 
              placeholder="Institution" 
              value={institution} 
              onChange={e => setInstitution(e.target.value)} 
              required 
            />
          </Col>
        </Row>
      ) : (
        <div>
          <Row className="mb-2">
            <Col>
              <Form.Label>
                Role <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control 
                onPaste={(e: any) => {
                  e.preventDefault();
                  alert('copy pasting is not allowed')
                  return false;
                }}
                placeholder="Role" 
                value={role} 
                onChange={e => setRole(e.target.value)} 
                required 
              />
            </Col>
          </Row>

          <Row className="mb-2">
            <Col>
              <Form.Label>
                Company <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control 
                onPaste={(e: any) => {
                  e.preventDefault();
                  alert('copy pasting is not allowed')
                  return false;
                }}
                placeholder="Company" 
                value={company} 
                onChange={e => setCompany(e.target.value)} 
                required={type === 'work' || type === 'internship'} 
              />
            </Col>
          </Row>
        </div>
      )}

      <Row className="mb-2">
        <Col>
          <Form.Label>
            City <span style={{ color: 'red' }}>*</span>
          </Form.Label>
          <Form.Control 
            value={city} 
            onChange={e => setCity(e.target.value)} 
            required 
          />
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <Form.Label>
            Start Date <span style={{ color: 'red' }}>*</span>
          </Form.Label>
          <Form.Control 
            type="date" 
            value={startDate} 
            onChange={e => setStartDate(e.target.value)} 
            required 
          />
        </Col>
        <Col>
          <Form.Label>
            End Date
          </Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            onChange={e => setEndDate(e.target.value)}
            disabled={present}
          />
        </Col>
        <Col className="d-flex align-items-end">
          <Form.Check
            type="checkbox"
            label="Present"
            checked={present}
            onChange={e => setPresent(e.target.checked)}
          />
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <Form.Label>
            Description <span style={{ color: 'red' }}>*</span>
          </Form.Label>
          <Form.Control
            onPaste={(e: any) => {
              e.preventDefault();
              alert('copy pasting is not allowed')
              return false;
            }}
            as="textarea"
            rows={3}
            placeholder="Description"
            value={description}
            spellCheck={true}
            onChange={e => {
              const input = e.target.value;
          
              if (input.length <= 700) {
                setDescription(input);
              }
            }}
            required
          />
          <Form.Text muted>
            {description.length} / 700 characters
          </Form.Text>
        </Col>
      </Row>

      <Row>
        <Col className="d-flex justify-content-end">
          <Button style={{marginRight: '4px'}} onClick={handleAdd}>Update</Button>
          {type === 'work' && work.length > 0 && <Button onClick={handleDelete}>Delete</Button>}
          {type === 'education' && educations.length > 0 && <Button onClick={handleDelete}>Delete</Button>}
          {type === 'internship' && internships.length > 0 && <Button onClick={handleDelete}>Delete</Button>}
        </Col>
      </Row>
    </div>
  );
};

export default Experience;
